import * as React from 'react';
import Styles from './with-menu.module.scss';
const NoMenu = () => {
    return (React.createElement("div", { className: Styles.rightContentWrap },
        React.createElement("div", { className: Styles.rightContent },
            React.createElement("div", { className: Styles.rightContentBg },
                React.createElement("div", { className: Styles.rightContentScan })))));
};
export default NoMenu;
